import React, { useCallback, useMemo, useState } from 'react';
import { Grid, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { CommandPanels, EditorControls, withBaseEditor } from '../../BaseEditor';
import ImageInput from '../../BaseEditor/imageField/imageField';
import { withLabel } from '../../BaseEditor/withLabel';
import TPs from './tp';

const LabeledImageInput = withLabel(ImageInput);

function OrgEditor({
  getControl, data, dataSetter, currentUser, fields,
}) {
  const onChangeFile = useCallback(
    (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const value = {
          file: reader.result,
          filename: file.name,
        };
        dataSetter({ logo: value });
      };
    },
    [dataSetter],
  );
  const [tab, setTab] = useState(currentUser.is_superuser ? 'general' : 'details');

  const districtFilter = useMemo(
    () => ((data.province && data.province.id) ? { province: data.province.id } : {}),
    [data.province],
  );

  return (
    <TabContext value={tab}>
      <TabList onChange={(e, v) => setTab(v)} textColor="primary" indicatorColor="primary">
        {currentUser.is_superuser && (
        <Tab value="general" label="Загальне" />
        )}
        <Tab value="details" label="Деталі" />
        <Tab value="accounts" label="Налаштування рахунків для оплат" disabled={!data.id} />
      </TabList>
      {currentUser.is_superuser && (
      <TabPanel value="general">
        <Grid container>
          <Grid item sm={12}>
            {getControl('name')}
          </Grid>
          <Grid item sm={3}>
            <LabeledImageInput
              label="Логотип"
              onChange={onChangeFile}
              value={data.logo}
              width="150px"
            />
          </Grid>
          <Grid item sm={9}>
            {getControl('province', { canErase: true })}
            {getControl('district', { canErase: true, filter: districtFilter, disabled: !(data.province && data.province.id) })}
            {getControl('addr_prefix', { rows: 4 })}
          </Grid>
          <Grid item sm={3}>
            {getControl('hide_e')}
          </Grid>
          <Grid item sm={9}>
            <EditorControls.TextInput
              value={data.comment}
              onChange={(e, v) => dataSetter({ comment: v })}
              label="Коментар"
            />
          </Grid>

        </Grid>
      </TabPanel>
      )}
      <TabPanel value="details">
        <Grid container spacing={2}>
          <Grid item sm={6}>
            {getControl('code')}
          </Grid>
          <Grid item sm={6}>
            {getControl('government_name')}
          </Grid>
          <Grid item sm={6}>
            {getControl('city')}
          </Grid>
          <Grid item sm={6}>
            {getControl('position')}
          </Grid>
          <Grid item sm={6}>
            <EditorControls.TextInput value={data.address} onChange={(e, v) => dataSetter({ address: v })} label="Повна адреса для акту" />
          </Grid>
          <Grid item sm={6}>
            <EditorControls.TextInput value={data.name_of_position} onChange={(e, v) => dataSetter({ name_of_position: v })} label="Повне ім'я для акту" />
          </Grid>
          <Grid item sm={6}>
            {getControl('landlord')}
          </Grid>
          <Grid item sm={6}>
            {getControl('edrpou')}
          </Grid>
          <Grid item sm={6}>
            {getControl('mfo')}
          </Grid>
          <Grid item sm={6}>
            {getControl('name_for_account')}
          </Grid>
          <Grid item sm={6}>
            {getControl('recipient_of_funds')}
          </Grid>
          {currentUser.is_superuser && (
          <Grid item sm={6}>
            {getControl('type_of_contract')}
          </Grid>
          )}
        </Grid>

      </TabPanel>
      <TabPanel value="accounts">
        <TPs.AccountsForInvoices
          data={data.accountforinvoicehistory_set}
          options={fields.accountforinvoicehistory_set}
          onChange={(e, newRecs) => dataSetter({ accountforinvoicehistory_set: newRecs })}
          orgId={data.id}
        />
      </TabPanel>
    </TabContext>
  );
}

OrgEditor.propTypes = {
  getControl: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    comment: PropTypes.string,
    address: PropTypes.string,
    name_of_position: PropTypes.string,
    province: PropTypes.shape({
      id: PropTypes.number,
    }),
    accountforinvoicehistory_set: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  fields: PropTypes.shape({
    accountforinvoicehistory_set: PropTypes.shape({}),
  }).isRequired,
  dataSetter: PropTypes.func.isRequired,
  currentUser: PropTypes.shape().isRequired,

};
export default withBaseEditor(OrgEditor, '/api/catalog/orgs/', CommandPanels.catCommandPanel);
